<template>
  <div
    class="bg-secondary basic-type text-primary position-relative key-note"
    id="section-keynote"
  >
    <img
      v-if="imageVisible"
      src="@/assets/image/background wave-2.png"
      class="position-absolute key-note-wave"
    />
    <div
      v-if="imageVisible"
      class="wave-mask position-absolute start-0 top-0 w-100 h-100 bg-secondary"
    ></div>
    <div class="content container-xl position-relative">
      <TitleUnderline :title="'專家洞察'" :large="false"></TitleUnderline>
      <p class="d-md-none mb-4">
        聆聽資訊業頂尖高層對市場趨勢的獨到見解，了解科技創新的核心獲得前所未有的行業洞見，
        共同探索未來科技發展的新視野。
      </p>
      <div class="row export">
        <div class="col-12 col-md-6">
          <img src="@/assets/image/digitimes logo.png" alt="digitimes" />
          <h2 class="mt-3">陳冠榮Aaron Chen / 分析師</h2>
          <h5 class="my-3">企業上雲與資安議題觀察</h5>
          <p class="mb-4">
            關注企業上雲及資安問題，我們將探討網路攻擊的發展趨勢，這直接影響著企業數位轉型。接著，數位轉型凸顯了資安的關鍵性，尤其在混合雲和多雲趨勢下，企業必須適應共同責任模型與零信任架構以應對雲端資安挑戰。其次，我們將討論企業上雲所帶來的複雜IT架構風險，這也是數位轉型過程中需要面對的重要議題之一。
          </p>
        </div>
        <div class="col-12 col-md-6">
          <img src="@/assets/image/digitimes logo.png" alt="digitimes" />
          <h2 class="mt-3">黃耀漢Wing Huang / 分析師</h2>
          <h5 class="my-3">生成式AI發展與市場觀察</h5>
          <p class="mb-4">
            探討生成式AI的發展與市場趨勢，我們會觀察生成式AI的發展趨勢，包括AI演算法和大型語言模型（LLM）。接著，我們將關注生成式AI市場的軟硬體趨勢，特別是運算晶片和應用程式的發展。最後，我們將通過企業生成式AI應用案例，深入了解其在實際業務中的應用與效果。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollMixin } from "@/mixins/scrollMixin";

export default {
  mixins: [scrollMixin],
};
</script>

<style lang="scss">
.key-note {
  overflow: hidden;
  z-index: 1;

  .export h2 {
    color: #27a1d8;
    font-size: 2rem;
  }
  @media (max-width: $lg) {
    .export h2 {
      font-size: 1.5rem;
    }

    h5 {
      font-size: 1rem;
    }

    p {
      font-size: 0.875rem;
    }
  }

  .key-note-wave {
    width: 110%;
    height: 100%;
    left: -5%;
    top: -40%;
    z-index: 2;
  }

  .wave-mask {
    animation: right-to-left 1.5s forwards;
    z-index: 3;
  }

  .content {
    z-index: 4;
  }
}
</style>
